<form [formGroup]="WALLETS_FORM">
  <section class="WALLETS_section wrapper">
    <div class="wrapperInner">
      <div class="innerWrapper">
        <div class="cardWrapper">
          <mat-form-field appearance="outline" floatLabel="always" class="w-75">
            <mat-label>Select Wallet</mat-label>
            <input matInput placeholder="Select wallet banking" formControlName="wallets_banking_value" [value]="selectedWallet" readonly>
            <mat-error *ngIf="WALLETS_FORM.controls['wallets_banking_value'].hasError('required')"><strong>Select Wallet Banking</strong> is required.</mat-error>
          </mat-form-field>
          <div class="payment_list">
            <mat-radio-group formControlName="wallets_banking_value">
              <mat-radio-button *ngFor="let item of WALLETS_LIST  | bankingOdder: term ; let i = index" color="primary" [value]="item" (change)="onRadiowalletChange($event)">
                <div class="paymentwrap">
                  <img [src]="item.logo" [alt]="item.name" class="img-fluid" onerror="this.src='../../../assets/main/payment_dummy.png'">&nbsp;&nbsp;<span>{{item.name}}</span>
                </div>
              </mat-radio-button>
            </mat-radio-group>
            <div class="noResult" *ngIf="(WALLETS_LIST | bankingOdder: term).length === 0">
              <img src="../../../assets/main/debt.png" alt="Not Found">
              <h4>No results found.</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</form>